import React from "react";
import { ArrowRightIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/offer";
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  id,
  className = ""
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-2 rounded-2xl bg-cta px-5 py-5 text-center font-display text-lg font-black uppercase tracking-wide text-ink shadow-[0_6px_0_#B88600] transition-[transform,box-shadow,background-color] duration-150 ease-out hover:bg-ctaHover active:translate-y-[4px] active:shadow-[0_2px_0_#B88600] focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/40 sm:text-xl ${className}`} data-id="element-32" data-mp="hhj26x77xry1">
      <span data-id="element-33" data-mp="vdmqyazbp834">{label}</span>
      <ArrowRightIcon className="h-6 w-6 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-34" data-mp="19as2urlpx16a" />
    </a>;
}